import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { YourInfoGrid } from './YourInfo.styles';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { FormValues } from '../../PersonalInfo.meta';
import { InputMask } from '../../../../CommonComponents/OPL/Input/InputMask';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { FilingStatus, PersonalInfoDTO } from '../../api/usePersonalInfoQuery';
import { SectionHeading } from '../../PersonalInfo.styles';

interface Props {
  data: PersonalInfoDTO;
  isEstatePlanning: boolean;
  setShowPartnerSection(showPartnerSection: boolean): void;
}

export const YourInfo = ({ data, isEstatePlanning, setShowPartnerSection }: Props) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <section>
      <SectionHeading as="h2">Your Info</SectionHeading>

      <YourInfoGrid as="section">
        <Input
          {...register('personalInfo.principal.firstName')}
          label="First Name"
          placeholder="First"
          formVariant={errors.personalInfo?.principal?.firstName ? 'error' : undefined}
          helperText={errors.personalInfo?.principal?.firstName?.message}
          autoComplete="given-name"
          css="grid-column: 1 / span 2"
        />

        <Input
          {...register('personalInfo.principal.lastName')}
          label="Last Name"
          placeholder="Last"
          autoComplete="family-name"
          css="grid-column: 3 / span 2"
        />

        <div />

        <InputMask
          {...register('personalInfo.principal.dob')}
          label="Date of Birth"
          mask="99/99/9999"
          placeholder="MM/DD/YYYY"
          leftIcon="far fa-calendar-alt"
          formVariant={errors.personalInfo?.principal?.dob ? 'error' : undefined}
          helperText={errors.personalInfo?.principal?.dob?.message}
          autoComplete="bday"
        />

        <Controller
          control={control}
          name="personalInfo.filingState"
          render={({ field }) => (
            <Select
              label="Filing State"
              value={data.FilingStateOptions.find(({ value }) => value === field.value)}
              onChange={opt => {
                if (opt) {
                  setValue('personalInfo.filingState', opt.value, { shouldDirty: true });
                }
              }}
              options={data.FilingStateOptions.filter(({ IsInsideUS }) => {
                if (isEstatePlanning) {
                  return IsInsideUS;
                }

                return true;
              })}
            />
          )}
        />

        <Controller
          control={control}
          name="personalInfo.filingStatus"
          render={({ field }) => (
            <Select
              label="Filing Status"
              value={data.FilingStatusOptions.find(({ value }) => value === field.value)}
              onChange={opt => {
                if (opt) {
                  setValue('personalInfo.filingStatus', opt.value, { shouldDirty: true });

                  /*
                   * Force the user to enter Partner information when
                   * filing status is of type "Married"
                   */
                  if (
                    opt.value === FilingStatus.MarriedFilingJointly ||
                    opt.value === FilingStatus.MarriedFilingSeparate
                  ) {
                    setShowPartnerSection(true);
                  }
                }
              }}
              options={data.FilingStatusOptions}
              css="grid-column: 3 / span 2"
            />
          )}
        />
      </YourInfoGrid>
    </section>
  );
};
